<template>
    <div class="fixed_module_container">
        <ConsumeUno/>
    </div>
</template>

<script>
import ConsumeUno from '@/components/game/fixed/consume/uno.vue'

export default {
    name: 'consumePanel',
    components: {
        ConsumeUno
    },
}
</script>
